module.exports = __webpack_public_path__ + "img/webnew50.871c6cef.jpg";